import { useCallback } from 'react';

/**
 * This is a thin wrapper around useCallback to make the semantics clear when we want to
 * wrap a callback to ensure it does not trigger an endless render loop.
 */
// eslint-disable-next-line react-hooks/exhaustive-deps
export const useConstCallback = (cb) => useCallback(cb, []);
